import Phaser from 'phaser';
import { GAME_H, GAME_W } from './config';

/**
 * Integer nearest-neighbour zoom with letterbox/pillarbox. Falls back to fractional zoom only when
 * the window is smaller than the logical canvas (mobile portrait), keeping a stable box.
 */
export function computeZoom(winW: number, winH: number, forced: 'auto' | 1 | 2 | 3): number {
  if (forced !== 'auto') return forced;
  const z = Math.floor(Math.min(winW / GAME_W, winH / GAME_H));
  if (z >= 1) return z;
  return Math.max(0.25, Math.min(winW / GAME_W, winH / GAME_H));
}

export function applyZoom(game: Phaser.Game, forced: 'auto' | 1 | 2 | 3): number {
  const parent = game.scale.parent as HTMLElement | null;
  const w = parent?.clientWidth || window.innerWidth;
  const h = parent?.clientHeight || window.innerHeight;
  const z = computeZoom(w, h, forced);
  game.scale.setZoom(z);
  const canvas = game.canvas;
  canvas.style.width = `${Math.round(GAME_W * z)}px`;
  canvas.style.height = `${Math.round(GAME_H * z)}px`;
  canvas.style.imageRendering = 'pixelated';
  return z;
}
